/**
 * Der Hinweis vor dem Ersetzen eines Grundrisses (#735).
 *
 * Das Ersetzen ist nicht umkehrbar, also muss vorher dastehen, was es kostet — in Stückzahlen,
 * nicht als allgemeine Warnung. Wer liest, dass "5 Räume gelöscht" und "12 Geräte neu zu
 * platzieren" sind, kann die Entscheidung treffen; "Daten gehen verloren" kann das nicht.
 */

import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Properties {
  open: boolean;
  /** Räume auf der Etage, die gelöscht werden. */
  spaces: number;
  /** Geräte, die ihre Position verlieren (die Etage behalten sie). */
  assets: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function FloorplanResetDialog(properties: Properties) {
  const { t } = useTranslation();

  return (
    <Dialog open={properties.open} onOpenChange={(open) => !open && properties.onCancel()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("floorplanReset.title")}</DialogTitle>
          <DialogDescription>{t("floorplanReset.intro")}</DialogDescription>
        </DialogHeader>

        <ul className="flex list-disc flex-col gap-2 pl-5 text-sm">
          <li>{t("floorplanReset.spaces", { count: properties.spaces })}</li>
          <li>{t("floorplanReset.assets", { count: properties.assets })}</li>
          <li>{t("floorplanReset.scale")}</li>
        </ul>

        <DialogFooter>
          <Button variant="outline" onClick={properties.onCancel}>
            {t("floorplanReset.cancel")}
          </Button>
          <Button variant="destructive" onClick={properties.onConfirm}>
            {t("floorplanReset.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
